import { useAppStore } from "@/store/app";

const CF_V1_WHITELISTED_LOCATIONS: ReadonlySet<string> = Object.freeze(
  new Set([
    // prod
    "uzx4OBY5GItBgtK4KVjQ",
    "tuGJcsuK7QASwnV7JhGL",
    "lb0ZshUxr6iIivhr6LMQ",
    "Ctx4S06LKQs1FPvH4Gco",
    "o7c1SGbyWHhkMUJTiBPb",
    "b6TbeT8dR1j4atyxkkYj",
    "fRbIpIoGXosF4mjdcdCd",
    // non-prod
    "Z4rC8YvgFIpdcC6Pidwb",
    "udi8s2CdQHEo0WuAXefn",
    "swnxBdYr5hprBm6ZC3JX",
    "xkIRDA2s5C3Hpn563fzM",
    "HChooFuiyPpVYzeJ4HMe",
    "7dwE0PSXv7hvkTmUC8VL",
  ])
);

/**
 * Checks whether a location can use Custom Fields Phase 1 features.
 *
 * @param locationId - Current sub-account location identifier.
 * @returns `true` when the location is included in the rollout allowlist.
 */
export const isLocationCfV1Whitelisted = (locationId?: string): boolean =>
  !!locationId && CF_V1_WHITELISTED_LOCATIONS.has(locationId);

/** Labs flag passed by the host to enable Custom Fields Phase 1. */
export const NEW_CUSTOM_FIELDS_LABS_FLAG = "new-custom-fields";

/** Enables Custom Fields Phase 1 for allowlisted locations or Labs opt-ins. */
export const isCfV1Enabled = (locationId?: string): boolean =>
  isLocationCfV1Whitelisted(locationId) || !!useAppStore().isNewCustomFieldsEnabled;
